<template>
    <div class="bg-grey-lighten-4 py-15">
        <v-container>
            <v-row class="justify-center">
                <v-col
                    md="5"
                    cols="12">
                    <v-card 
                        flat
                        rounded="0">
                        <div class="pa-10">
                            <h5 
                                class="z-subtitle text-primary">
                                Register
                            </h5>

                            <div class="mt-7">
                                <v-text-field
                                    v-model="name"
                                    prepend-inner-icon="mdi-account"
                                    label="name"
                                    variant="outlined"
                                    :error-messages="getValidateError('name')"
                                    :class="getValidateError('name') ? 'mb-3':''">
                                </v-text-field>
                                <v-text-field
                                    v-model="phone"
                                    prepend-inner-icon="mdi-cellphone"
                                    label="Phone"
                                    variant="outlined"
                                    :error-messages="getValidateError('phone')"
                                    :class="getValidateError('phone') ? 'mb-3':''">
                                </v-text-field>
                                <v-text-field
                                    v-model="email"
                                    prepend-inner-icon="mdi-email"
                                    label="Email"
                                    variant="outlined"
                                    :error-messages="getValidateError('email')"
                                    :class="getValidateError('email') ? 'mb-3':''">
                                </v-text-field>
                                <v-text-field
                                    v-model="password"
                                    prepend-inner-icon="mdi-lock"
                                    label="Password"
                                    variant="outlined"
                                    :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                    :type="visible ? 'text' : 'password'"
                                    @click:append-inner="visible = !visible"
                                    :error-messages="getValidateError('password')"
                                    :class="getValidateError('password') ? 'mb-3':''">
                                </v-text-field>

                                <v-checkbox 
                                    v-model="tnc"
                                    :error-messages="getValidateError('tnc')">
                                    <template v-slot:label>
                                        <div>
                                            I agree to receive information about
                                            news, sales, products from IGA
                                            by continuing, I agree to  
                                            <a
                                                href="/privacy-policy"
                                                target="_blank">
                                                privacy policy
                                            </a>
                                        </div>
                                    </template>
                                </v-checkbox>

                                <div 
                                    v-if="msgError"
                                    class="text-red mb-4">
                                    {{ msgError }}
                                </div>
                                
                                <div 
                                    v-if="msgSuccess"
                                    class="text-green mb-4">
                                    {{ msgSuccess }}
                                </div>
                                

                                <v-btn 
                                    class="mt-5"
                                    size="x-large"
                                    block
                                    @click="register"
                                    :loading="loading">
                                    Register
                                </v-btn>

                                <div class="text-center mt-7">
                                    <router-link 
                                        to="/login"
                                        class="text-primary">
                                        Sign in
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
    
</template>

<script setup>
    import { ref } from 'vue'
    import api from '@/api'

    document.title = "Register"

    const visible = ref(false)

    const name = ref('')
    const email = ref('')
    const password = ref('')
    const phone = ref('')
    const tnc = ref(true)
    
    const loading = ref(false)

    const msgValidate = ref('')
    const msgError = ref('')
    const msgSuccess = ref('')

    async function register(){
        loading.value = true
        msgValidate.value = ''
        msgError.value = ''
        msgSuccess.value = ''
        await api.post('register', {
            name: name.value,
            email: email.value,
            phone: phone.value,
            tnc: tnc.value,
            password: password.value
        })
        .then((resp) => {
            loading.value = false
            localStorage.setItem('token', resp.data.token)
            msgSuccess.value = resp.data.message

            name.value = ''
            email.value = ''
            phone.value = ''
            tnc.value = ''
            password.value = ''
        })
        .catch((err) => {
            loading.value = false
            if(err.response.status == 422){
                msgValidate.value = err.response.data.errors
            } 
            if(err.response.status == 429){
                msgError.value = 'Please try again in 30 minutes'
            }
            if(err.response.status == 500){
                msgError.value = 'Internal server error'
            } 
        })
    }

    function getValidateError(field) {
        if (msgValidate.value && msgValidate.value[field] && msgValidate.value[field][0]) {
            return msgValidate.value[field][0];
        } else {
            return '';
        }
    }

</script>